"use client";

import GameController from "ui/templates/Game/GameController";
import { useMountEffect } from "@react-hookz/web";
import trackPage from "shared/analytics/mixpanel/trackPage";
import { pages } from "shared/analytics/mixpanel/constants";
import {
  useTodoQuestions,
  Props as TodosQuestionProps,
} from "./useTodoQuestions";
import { Todo } from "shared/todos/Todo";
import TodosContextProvider from "shared/todos/TodosContextProvider";
import LoadingScreen from "ui/atoms/Loading/LoadingScreen";
import EndOfRoundScreen from "./EndOfRoundScreen";
import useParsedSearchParams from "./useParsedSearchParams";
import useRoundId from "./useRoundId";

interface Props {
  todos: Todo[];
}

export default function TodoQuestionsPageWrapper({ todos }: Props) {
  useMountEffect(() => {
    trackPage(pages.mixEarTraining);
  });

  return (
    <TodosContextProvider todos={todos}>
      <TodoQuestionsPage />
    </TodosContextProvider>
  );
}

function TodoQuestionsPage() {
  const searchParams = useParsedSearchParams();
  const { difficulty, games, todoIds, back } = searchParams;
  const roundId = useRoundId(searchParams);
  const todosQuestionProps: TodosQuestionProps =
    todoIds.length > 0
      ? {
          type: "by-id",
          roundId,
          todoIds,
        }
      : {
          type: "by-category",
          difficulty,
          games,
          roundId,
        };
  const { currentQuestion, next, remaining } =
    useTodoQuestions(todosQuestionProps);

  if (remaining === 0) {
    return <EndOfRoundScreen {...todosQuestionProps} href={back} />;
  }

  if (!currentQuestion) {
    return <LoadingScreen noAnimation loading theme="green" />;
  }

  return (
    <GameController
      question={currentQuestion}
      onRequestNext={next}
      exitUrl={back}
      navbarContextTitle={`${remaining} todos`}
    />
  );
}
